import { useMutation } from "react-query";
import { apiCall } from "Apis/BaseApi";
import { IFileInformationDto, IUploadFileDto } from "Apis/Models/IFileDto";

export const useBase64File = () => {
    
    return async (file: File, includeData: boolean = false): Promise<string> => {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                // @ts-ignore
                let payload = reader.result.split(',')[1];
        
                if (includeData) {
                    payload = reader.result;
                }
        
                resolve(payload);
            }
            reader.onerror = error => reject(error);
        });
    }
}

export const useUploadFile = () => {
    return useMutation(async (file: IUploadFileDto): Promise<IFileInformationDto> => {
        return await apiCall<IFileInformationDto>({
            url: `/files`,
            method: 'POST',
            data: file
        })
    })
}
